import { Injectable } from '@angular/core';
import { PublicCustomer } from 'src/app/faq/core/models/public-customer.model';
import { FaqInstanceAdminDTO } from '@settings-models/faq-instance-admin-dto.model';
import { CommunityUser } from 'src/sb-tools/typescript/models/community-user.model';

@Injectable({ providedIn: 'root' })
// todo: check properties
export class CommonDataFaqService {
    communityName: string;
    currentState: string;
    customerSettings: PublicCustomer;
    displayName: string;
    faqSettings: FaqInstanceAdminDTO;
    isFbApp: boolean;
    language: 'nb' | 'en' | 'sv_SE' | 'da_DK' | 'fi';
    sbChannelImage = 'https://socialboards.com/en/wp-content/uploads/sites/5/2019/01/Channels.png'; // todo: check
    title: string;
    totalUsefulness: number;
    user: CommunityUser;
    viewCount: number;

    get faqName(): string {
        return this._faqName || '';
    }

    set faqName(val: string) {
        this._faqName = val;
    }

    private _faqName: string;

    setInstanceData(data) {
        this.viewCount = data.viewCount;
        this.totalUsefulness = data.totalUsefulness;
    }
}
